import { CartAddEvent } from '@theme/events';

/**
 * @typedef {object} AnalyticsCartItem
 * @property {number | string} variant_id
 * @property {string | null} sku
 * @property {number} price
 * @property {string} product_title
 * @property {string | null} variant_title
 */

/** @typedef {{ items?: AnalyticsCartItem[] }} AnalyticsCart */

/**
 * Pushes an event for every item successfully added through the theme cart flows.
 *
 * @param {Event} event
 */
function trackProductAddedToCart(event) {
  const cartEvent = /** @type {CartAddEvent} */ (event);
  const cart = /** @type {AnalyticsCart | undefined} */ (cartEvent.detail?.resource);
  const cartItems = cart?.items;
  const addedItems = cartEvent.detail?.data?.addedItems;

  if (!Array.isArray(cartItems) || !Array.isArray(addedItems)) return;

  const analyticsWindow = /** @type {Window & typeof globalThis & { dataLayer: Array<Record<string, unknown>> }} */ (
    window
  );
  analyticsWindow.dataLayer = analyticsWindow.dataLayer || [];

  for (const addedItem of addedItems) {
    if (addedItem.quantity <= 0) continue;

    const cartItem = cartItems.find((item) => String(item.variant_id) === String(addedItem.variantId));
    if (!cartItem) continue;

    analyticsWindow.dataLayer.push({
      event: 'product_added_to_cart',
      item_id: cartItem.sku || String(cartItem.variant_id),
      price: cartItem.price / 100,
      item_name: cartItem.product_title,
      item_variant: cartItem.variant_title,
      quantity: addedItem.quantity,
    });
  }
}

document.addEventListener(CartAddEvent.eventName, trackProductAddedToCart);
